import React from 'react'

import TourV1ItemCard from './TourV1ItemCard'
import TourV2ItemCard from './TourV2ItemCard'
import ItineraryItemCard from '../ItineraryItemCard'
import { ItemCardVariant } from '../types'

import Caption from 'components/Luxkit/Typography/Caption'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import { isTourV1Offer, isTourV2Offer } from 'lib/offer/offerTypes'
import TripSummaryCardLoadingSkeleton from 'tripPlanner/components/TripSummary/TripSummaryCardLoadingSkeleton'
import { useOffer } from 'tripPlanner/hooks/api'
import { TourItem } from 'tripPlanner/types/tripItem'
import {
  formatDatesAndDays,
  formatDurationDaysIfMultipleDays,
  formatStartAndEndLocation,
} from 'tripPlanner/utils'

interface Props {
  item: TourItem
  tripNameLabel?: React.ReactNode
  variant: ItemCardVariant
}

export default function LETourItemCard({
  item,
  tripNameLabel,
  variant,
}: Props) {
  const { data: offer, isLoading } = useOffer(item.code)
  const timeFormat = useRegionTimeFormat()
  if (isLoading) return <TripSummaryCardLoadingSkeleton />
  if (!offer) {
    const timeDescription = formatDatesAndDays(item, timeFormat)
    const durationDescription = formatDurationDaysIfMultipleDays(item)
    return (
      <ItineraryItemCard
        item={item}
        name={item.name}
        imgId={item.savedItemData?.imageIds?.[0]}
        locationDescription={formatStartAndEndLocation(item)}
        descriptors={[timeDescription, durationDescription]}
        printDescriptors={[timeDescription, durationDescription]}
        bottomContent={
          <Caption variant="medium">Unable to fetch offer data</Caption>
        }
        tripNameLabel={tripNameLabel}
        variant={variant}
      />
    )
  } else if (isTourV1Offer(offer)) {
    return (
      <TourV1ItemCard
        item={item}
        offer={offer}
        tripNameLabel={tripNameLabel}
        variant={variant}
      />
    )
  } else if (isTourV2Offer(offer)) {
    return (
      <TourV2ItemCard
        item={item}
        offer={offer}
        tripNameLabel={tripNameLabel}
        variant={variant}
      />
    )
  }

  return null
}
